import { API } from '@/modules/api-service/api-service';
import type { Core, Data } from '@strapi/types';

const url = '/document-access';

export const getSharedDocuments = async (todayDateStr: string) => {
	const { data: response } = await API().post<
		Core.Helpers.Controllers.GetResponseBody<'api::document-access.document-access', 'getSharedDocuments'>,
		Core.Helpers.Controllers.GetRequestBody<'api::document-access.document-access', 'getSharedDocuments'>
	>(`${url}/shared-documents`, { todayDateStr });

	return response;
};

export const getInvitations = async () => {
	const { data: response } = await API().get<
		Core.Helpers.Controllers.GetResponseBody<'api::document-access.document-access', 'getInvitations'>
	>(`${url}/invitations`);

	return response;
};

export const getProjectDocumentAccesses = async ({
	projectDocumentId,
}: {
	projectDocumentId: Pick<Data.Entity<'api::project-document.project-document'>, 'documentId'>['documentId'];
}) => {
	const { data: response } = await API().get<
		Core.Helpers.Controllers.GetResponseBody<'api::document-access.document-access', 'getProjectDocumentAccesses'>
	>(`${url}/shared-documents/${projectDocumentId}`);

	return response;
};

////dasdsadasdsadasdsadasdasd

export const createAccessApi = async ({
	documentDocumentId,
	body,
}: {
	documentDocumentId: Data.Entity<'api::project-document.project-document'>['documentId'];
	body: Core.Helpers.Controllers.GetRequestBody<'api::document-access.document-access', 'create'>;
}) => {
	return await API().post<
		Core.Helpers.Controllers.GetResponseBody<'api::document-access.document-access', 'create'>,
		Core.Helpers.Controllers.GetRequestBody<'api::document-access.document-access', 'create'>
	>(`${url}/create/${documentDocumentId}`, body);
};

export const acceptAccessApi = async ({
	accessDocumentId,
}: {
	accessDocumentId: Data.Entity<'api::document-access.document-access'>['documentId'];
}) => {
	return await API().post<Core.Helpers.Controllers.GetResponseBody<'api::document-access.document-access', 'accept'>, {}>(
		`${url}/accept/${accessDocumentId}`,
		{},
	);
};

export const updateAccessLevelApi = async ({
	accessDocumentId,
	body,
}: {
	accessDocumentId: Data.Entity<'api::document-access.document-access'>['documentId'];
	body: Core.Helpers.Controllers.GetRequestBody<'api::document-access.document-access', 'updateAccessLevel'>;
}) => {
	return await API().post<
		Core.Helpers.Controllers.GetResponseBody<'api::document-access.document-access', 'updateAccessLevel'>,
		Core.Helpers.Controllers.GetRequestBody<'api::document-access.document-access', 'updateAccessLevel'>
	>(`${url}/update-access-level/${accessDocumentId}`, body);
};

export const updateAccessPeriodApi = async ({
	accessDocumentId,
	body,
}: {
	accessDocumentId: Data.Entity<'api::document-access.document-access'>['documentId'];
	body: Core.Helpers.Controllers.GetRequestBody<'api::document-access.document-access', 'updatePeriod'>;
}) => {
	return await API().post<
		Core.Helpers.Controllers.GetResponseBody<'api::document-access.document-access', 'updatePeriod'>,
		Core.Helpers.Controllers.GetRequestBody<'api::document-access.document-access', 'updatePeriod'>
	>(`${url}/update-access-period/${accessDocumentId}`, body);
};

export const revokeAccessApi = async ({
	accessDocumentId,
}: {
	accessDocumentId: Data.Entity<'api::document-access.document-access'>['documentId'];
}) => {
	return await API().delete<Core.Helpers.Controllers.GetResponseBody<'api::document-access.document-access', 'revokeAccess'>>(
		`${url}/revoke/${accessDocumentId}`,
	);
};

export const leaveSharedDocumentApi = async ({
	accessDocumentId,
}: {
	accessDocumentId: Data.Entity<'api::document-access.document-access'>['documentId'];
}) => {
	return await API().delete<Core.Helpers.Controllers.GetResponseBody<'api::document-access.document-access', 'leaveDocumentAccess'>>(
		`${url}/leave/${accessDocumentId}`,
	);
};

export const getLastEditorNameBySessionApi = async ({
	documentId,
}: {
	documentId: Data.Entity<'api::project-document.project-document'>['documentId'];
}) => {
	return await API().post<
		Core.Helpers.Controllers.GetResponseBody<'api::document-access.document-access', 'getLastEditorNameBySession'>,
		{}
	>(`${url}/edited-by/${documentId}`, {});
};

export const checkIfThereIsUnacceptedAccessesApi = async () => {
	return await API().post<
		Core.Helpers.Controllers.GetResponseBody<'api::document-access.document-access', 'checkIfThereIsUnacceptedAccesses'>,
		{}
	>(`${url}/check-unaccepted-accesses`, {});
};
